function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "audit-trails_svg__a",
  x1: "0%",
  x2: "89.643%",
  y1: "55.339%",
  y2: "5.055%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#DCE1EC",
  strokeLinejoin: "round",
  strokeWidth: 6.982,
  d: "M16.516 29.54c7.193 0 13.024-5.831 13.024-13.024 0-7.194-5.831-13.025-13.024-13.025-7.193 0-13.024 5.831-13.024 13.025 0 7.193 5.83 13.024 13.024 13.024zm46.87 0c7.193 0 13.024-5.831 13.024-13.024 0-7.194-5.831-13.025-13.024-13.025-7.193 0-13.024 5.831-13.024 13.025 0 7.193 5.83 13.024 13.024 13.024zm-46.87 47.27c7.193 0 13.024-5.83 13.024-13.024 0-7.194-5.831-13.025-13.024-13.025-7.193 0-13.024 5.831-13.024 13.025s5.83 13.025 13.024 13.025zm46.87 0c7.193 0 13.024-5.83 13.024-13.024 0-7.194-5.831-13.025-13.024-13.025-7.193 0-13.024 5.831-13.024 13.025s5.83 13.025 13.024 13.025zM29.54 16.517h20.821m-20.82 47.27h2.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DCE1EC",
  strokeDasharray: "5.274 5.274",
  strokeLinejoin: "round",
  strokeWidth: 6.982,
  d: "M37.314 63.786h7.91"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DCE1EC",
  strokeLinejoin: "round",
  strokeWidth: 6.982,
  d: "M47.861 63.786h2.5m-23.18-10.665L53.74 26.562"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#audit-trails_svg__a)",
  d: "M13.515 6.516a7 7 0 100 14 7 7 0 000-14zm53.87 7a7 7 0 10-14 0 7 7 0 0014 0m-53.87 40.27a7 7 0 100 14 7 7 0 000-14z",
  transform: "translate(3 3)"
}));

function SvgAuditTrails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 81
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MSI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCUiIHgyPSI4OS42NDMlIiB5MT0iNTUuMzM5JSIgeTI9IjUuMDU1JSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwOTA3RiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzQ4RDU5RiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggc3Ryb2tlPSIjRENFMUVDIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYuOTgyIiBkPSJNMTYuNTE2IDI5LjU0YzcuMTkzIDAgMTMuMDI0LTUuODMxIDEzLjAyNC0xMy4wMjQgMC03LjE5NC01LjgzMS0xMy4wMjUtMTMuMDI0LTEzLjAyNS03LjE5MyAwLTEzLjAyNCA1LjgzMS0xMy4wMjQgMTMuMDI1IDAgNy4xOTMgNS44MyAxMy4wMjQgMTMuMDI0IDEzLjAyNHptNDYuODcgMGM3LjE5MyAwIDEzLjAyNC01LjgzMSAxMy4wMjQtMTMuMDI0IDAtNy4xOTQtNS44MzEtMTMuMDI1LTEzLjAyNC0xMy4wMjUtNy4xOTMgMC0xMy4wMjQgNS44MzEtMTMuMDI0IDEzLjAyNSAwIDcuMTkzIDUuODMgMTMuMDI0IDEzLjAyNCAxMy4wMjR6bS00Ni44NyA0Ny4yN2M3LjE5MyAwIDEzLjAyNC01LjgzIDEzLjAyNC0xMy4wMjQgMC03LjE5NC01LjgzMS0xMy4wMjUtMTMuMDI0LTEzLjAyNS03LjE5MyAwLTEzLjAyNCA1LjgzMS0xMy4wMjQgMTMuMDI1czUuODMgMTMuMDI1IDEzLjAyNCAxMy4wMjV6bTQ2Ljg3IDBjNy4xOTMgMCAxMy4wMjQtNS44MyAxMy4wMjQtMTMuMDI0IDAtNy4xOTQtNS44MzEtMTMuMDI1LTEzLjAyNC0xMy4wMjUtNy4xOTMgMC0xMy4wMjQgNS44MzEtMTMuMDI0IDEzLjAyNXM1LjgzIDEzLjAyNSAxMy4wMjQgMTMuMDI1ek0yOS41NCAxNi41MTdoMjAuODIxbS0yMC44MiA0Ny4yN2gyLjUiLz48cGF0aCBzdHJva2U9IiNEQ0UxRUMiIHN0cm9rZS1kYXNoYXJyYXk9IjUuMjc0IDUuMjc0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYuOTgyIiBkPSJNMzcuMzE0IDYzLjc4Nmg3LjkxIi8+PHBhdGggc3Ryb2tlPSIjRENFMUVDIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYuOTgyIiBkPSJNNDcuODYxIDYzLjc4NmgyLjVtLTIzLjE4LTEwLjY2NUw1My43NCAyNi41NjIiLz48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJNMTMuNTE1IDYuNTE2YTcgNyAwIDEgMCAwIDE0IDcgNyAwIDAgMCAwLTE0em01My44NyA3YTcgNyAwIDEgMC0xNCAwIDcgNyAwIDAgMCAxNCAwbS01My44NyA0MC4yN2E3IDcgMCAxIDAgMCAxNCA3IDcgMCAwIDAgMC0xNHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiLz48L2c+PC9zdmc+";
export { SvgAuditTrails as ReactComponent };